import { render, staticRenderFns } from "./Topuprecord.vue?vue&type=template&id=68cdd20f&scoped=true&"
import script from "./Topuprecord.vue?vue&type=script&lang=js&"
export * from "./Topuprecord.vue?vue&type=script&lang=js&"
import style0 from "./Topuprecord.vue?vue&type=style&index=0&id=68cdd20f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cdd20f",
  null
  
)

export default component.exports